import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditor from "@ckeditor/ckeditor5-react";
import React from "react";
import { getDateParts } from "../../utils";

class ComponentName extends React.Component<any, any> {
  editorInstance: any = null;
  constructor(props: any) {
    super(props);
    this.state = {
      detail: [],
    };
  }

  componentDidUpdate(prevProps: any) {
    if (prevProps.bgColor !== this.props.bgColor) {
      this.updateEditorBackground(this.props.bgColor);
    }
  }

  updateEditorBackground = (color: string | null) => {
    if (!this.editorInstance) return;

    const editor = this.editorInstance;

    editor.editing.view.change((writer: any) => {
      const root = editor.editing.view.document.getRoot();

      if (color) {
        writer.setStyle("background-color", color, root);
      } else {
        writer.removeStyle("background-color", root);
      }
    });
  };

  render() {
    const { error, name, value, placeholder, bgColor } = this.props;
    console.log(bgColor);
    const { detail } = this.state;
    const editorConfiguration = {
      placeholder: placeholder,
      toolbar: [
        "heading",
        "|",
        "bold",
        "italic",
        "link",
        "numberedList",
        "bulletedList",
        "|",
        "insertTable",
        "tableColumn",
        "tableRow",
        "mergeTableCells",
      ],
    };

    return (
      <div className={error > 0 ? "border border-danger" : ""}>
        <CKEditor
          editor={ClassicEditor}
          config={editorConfiguration}
          data={value}
          onInit={(editor: any) => {
            this.editorInstance = editor;

            editor.editing.view.change((writer: any) => {
              const root = editor.editing.view.document.getRoot();
              writer.setStyle("height", "180px", root);

              if (bgColor) {
                writer.setStyle("background-color", bgColor, root);
              }
              if (this.props.onEditorReady) {
                this.props.onEditorReady(editor); // 👈 add this
              }
            });

            // Disable image paste and upload
            editor.editing.view.document.on(
              "clipboardInput",
              (evt: any, data: any) => {
                if (data.dataTransfer?.files?.length > 0) {
                  evt.stop();
                }
                const html = data.dataTransfer?.getData("text/html");
                if (html && /<img/i.test(html)) {
                  evt.stop();
                }
              },
              { priority: "highest" }
            );
          }}
          onChange={(event: any, editor: any) => {
            const data = editor.getData();
            this.onChange({ target: { name, value: data } });
          }}
          onBlur={(event: any, editor: any) => {}}
          onFocus={(event: any, editor: any) => {}}
        />
        {detail !== undefined && this.renderModifiedDate()}
      </div>
    );
  }

  renderModifiedDate = () => {
    const { modifiedOn } = this.state.detail;
    const mo = getDateParts(modifiedOn);
    return (
      <small className="float-right">
        content was saved in drafts on {mo.hour}:{mo.minute} {mo.amOrpm}
      </small>
    );
  };

  onChange = (e: any) => {
    this.setState({ content: e.target.value });
    this.props.onChange(e);
  };

  onPaste = (e: any, cleanData: any, maxCharCount: any, core: any) => {};
}

export default ComponentName;